import React, { useLayoutEffect } from 'react';

import { useRecoilState } from 'recoil';
import { mouseEffectState } from '@atom/setting/mouseEffect';
import MouseTrail from '@components/library/MouseEffect/mouseTrail';
import { masterSet } from '@masterSetting/masterSet/masterSetting';
import mouseSet from '@utils/cursorSetting';
import { useDocument } from '@nandorojo/swr-firestore';
import { SettingCollectionPath } from '@typings/collections.enum';
import { ImouseSet } from '@typings/setting/mouseSet.interface';

type Props = {};
function MouseEffect({ }: Props) {
  const [mouseEffect, setMouseEffect] = useRecoilState(mouseEffectState);

  const { data: mouseSetting } = useDocument<ImouseSet>(
    SettingCollectionPath.MOUSE,
    { listen: true },
  );

  // 마우스 설정
  useLayoutEffect(() => {
    // 마우스 옵션 없을 경우 default
    document.documentElement.style.setProperty(`--defaultCursorURL`, `url('')`);
    document.documentElement.style.setProperty(`--hoverCursorURL`, `url('')`);

    if (masterSet.cursorCustom && mouseSetting) {
      mouseSet(mouseSetting.cursor);
      setMouseEffect(mouseSetting.mouseEffect);
    }
  }, [mouseSetting]);

  return (
    <>
      {mouseEffect && (
        <MouseTrail
          color={mouseEffect.color}
          color2={mouseEffect.color2}
          shape={mouseEffect.shape}
          minSize={mouseEffect.minSize}
          maxLength={mouseEffect.number}
          direction={mouseEffect.direction}
          isActive={mouseEffect.isActive}
        />
      )}
    </>
  );
}

export default MouseEffect;
